import axios from 'axios'
import Cookies from 'js-cookie'

function isTokenInvalidError(error) {
  const message = error.response.data.message;
  return message === 'jwt expired' || message === 'jwt malformed';
}

function responseSuccessHandler(response) {
  return response.data;
}

function responseErrorHandler(error) {
  console.log(isTokenInvalidError(error))
  if (isTokenInvalidError(error)) {
    alert('登入時間過長或錯誤的token，請重新登入');
    API.defaults.headers.common['x-access-token'] = undefined;
    Cookies.remove('token');
    Cookies.remove('employee');
    Cookies.remove('manager');
    Cookies.remove('managerName');
    Cookies.remove('position');
    Cookies.remove('positionId');
    Cookies.remove('positionName');
    Cookies.remove('signing');
    location.hash = '#/login';
  } else if (error.response.status >= 500) {
    alert('伺服器發生錯誤，請聯絡管理人員')
  };
  return Promise.reject(error);
}

function getBaseUrl(){
  var baseUrl = '';
  if (location.href.includes('localhost')) {
      baseUrl = 'https://staging.ap.gladmobile.com';
  } else if (location.href.includes('staging.backstage.gladmobile.com')) {
      baseUrl = 'https://staging.ap.gladmobile.com';
  } else if (location.href.includes('daisuki.backstage.gladmobile.com')) {
    baseUrl = 'https://test-fleet.gladmobile.com';
  } else if (location.href.includes('staging-2.backstage.gladmobile.com')) {
    baseUrl = 'https://staging2.ap.gladmobile.com';
  } else if (location.href.includes('backstage.gladmobile.com')){
      baseUrl = 'https://test-fleet.gladmobile.com';
  } else {
    baseUrl = 'https://staging.ap.gladmobile.com';
  }
  return baseUrl
}
function getAPIUrl() {
  return getBaseUrl()+"/enterprise/api/web";
}

const API = axios.create({
  baseURL: getAPIUrl(),
  timeout: 1000*6,
});
API.defaults.headers.common['x-access-token'] = Cookies.getJSON('token');
API.interceptors.response.use(
  responseSuccessHandler,
  (error) => {
    responseErrorHandler(error);
  },
);

API.getBaseUrl = getBaseUrl();
API.getAPIUrl = getAPIUrl();

export default API;



// WEBPACK FOOTER //
// ./src/asset/js/API.js